<template>
  <div class="flex justify-center">
    <div class="flex items-center justify-center rounded-full h-[32px] w-[76px] mb-2">
      <img src="@/assets/paymentMethods/Visa.svg" class="h-[32px] w-[76px]" />
    </div>
  </div>
</template>
